import script from "./AppointementList.vue?vue&type=script&setup=true&lang=js"
export * from "./AppointementList.vue?vue&type=script&setup=true&lang=js"

import "./AppointementList.vue?vue&type=style&index=0&id=3191d8d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3191d8d2"]])

export default __exports__